const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
const STORAGE_KEY = 'cargoags_utm';

export const captureUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    KEYS.forEach(k => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    }
  } catch {}
};

export const getUtm = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
};
